import getStore from '../store';
import { mutator } from 'satcheljs';
import { setHideNotification } from '../actions/searchResultStoreActions';

/**
 * Set the flag whether to show notification bar or not.
 */
export let setHideNotificationMutator = mutator(setHideNotification, item => {
    let store = getStore();
    store.hideNotificationBar = item.setHideNotification;
});
